(function (angular) {
    angular.module("app").controller("CourseDetailCtrl", ["$scope", "$route", "SecurityService", "DialogService", function ($scope, $route, SecurityService, DialogService) {
        var courseCode = $route.current.params.courseCode;
    }]);
})(angular);